<template>
    <div class="collection-gift-item-wrapper">
        <div class="collection-gift-item" v-for="(item, index) in reversedChristmasWinesList" :key="index">
            <div class="advent-day-badge">{{ currentDayOfDecember - index }}</div>
            <div class="gift-bottle-img" :style="getImgUrl(item.bottlePicture)"></div>
            <div class="gift-wrapper">
                <div class="gift-wrapper-row1">
                    <div class="gift-wrapper-row1-wine">
                        <div class="gift-wrapper-row1-wine1">
                            <div class="gift-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                            <h3 class="gift-title">{{item.displayWineName}}</h3>
                        </div>
                        <div class="gift-wrapper-row1-wine2">
                            <div class="gift-wrapper-row1-wine2-text">{{item.regionName}}</div>
                            <div class="gift-wrapper-row1-wine2-text">
                                <div :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')" ></div> {{ $t(item.colorId == 1 ? 'red' : (item.colorId == 2 ? 'white' : 'champagne')) }}, {{item.appellation}}
                            </div>
                        </div>
                    </div>
                    <div class="gift-wrapper-row1-price">
                        <div class="gift-wrapper-row1-price1">Last trade:</div>
                        <div class="gift-wrapper-row1-price2">{{formatPrice(item.lastTradePrice.toFixed(2))}}</div>
                        <div class="gift-wrapper-row1-price3">Case size:
                            <div class="gift-wrapper-row1-price3">{{item.size}}l</div>
                        </div>
                    </div>
                    <div class="gift-wrapper-row1-btn">
                        <button class="gift-cart-btn" v-on:click.stop="() => { selectWine(item) }">{{ $t('buy') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {MOrders} from "@/store/mutations";
    import {GCommon, GMarket, GOrders, GUser} from "@/store/getters";
    import { directive } from "vue-awesome-swiper";
    import {AWines} from "@/store/actions";

export default {
    name: "ChristmasCollections",
    props: ['useSlider'],
    directives: {
        swiper: directive
    },
    data () {
        return {
            windowWidth: null,
            valid: true,
            deleteDialog: false,
            editDialog: false,
            editAddressSuccess: {
                visible: false,
                text: 'Address added successfully!'
            },
            editAddressFail: {
                visible: false,
                text: 'Please review again all the information and try again!'
            },
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                dynamicBullets: true
            }
        }
    },
    computed: {
        ...mapGetters({
            cartItemsList: GOrders.GET_CART_ITEMS,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            addressList: GUser.GET_ADDRESSES,
            collectionsList: GOrders.GET_CHRISTMAS_COLLECTIONS,
            christmasWinesList: GMarket.GET_CHRISTMAS_WINES,
            isLogged: GUser.GET_USER_LOGGED,
        }),
        billingAddress() {
            let address = null;

            this.addressList.forEach(element => {
                if (element.type === 1 || element.type === 3) {
                    address = element;

                    if ((element.countryId === 138 || element.countryId === 72) || element.vat === "") {
                        this.VATvalue = 0.2
                    }
                }
            });

            return address;
        },
        allCollections() {
            let localArr = []

            localArr.forEach((item) => {
                if (!item.selectedCollectionId) {
                    this.$store.commit(MOrders.UPDATE_COLLECTION_WINE, {
                        collectionIndex: localArr.indexOf(item),
                        selectedCollectionId: item.wines[0]?.collectionId,
                        price: item.wines[0]?.collectionPrice || item.price
                    });
                }
            })

            return localArr;
        },
        currentDayOfDecember() {
            const today = new Date();
            const currentMonth = today.getMonth(); // 0-11, where 11 is December

            // Only return current day if we're in December
            if (currentMonth === 11) {
                return today.getDate();
            }

            // If not December, return 0 (will show no items)
            return 0;
        },
        reversedChristmasWinesList() {
            if (!this.christmasWinesList) return [];
            const reversed = [...this.christmasWinesList].reverse();

            // Only show wines if we're in December
            if (this.currentDayOfDecember > 0) {
                // Take the last 'currentDayOfDecember' items (which correspond to badges 1 through currentDayOfDecember)
                return reversed.slice(-this.currentDayOfDecember);
            }

            // If not December, return empty array
            return [];
        }
    },
    methods: {
        formatPrice(price) {
            return `€${price}`
        },
        selectWine(item) {
            if (!this.isLogged) {
                this.$nuxt.$emit("showLoginModal", '');
                return;
            }

            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: ('/wine-trading-buy/') + item.wineId}));
            });
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        },
        getSelectedWinePrice(item) {
            if (!item.selectedCollectionId) {
                // Default to first wine's price if none selected
                return item.wines[0]?.collectionPrice || item.price;
            }
            const selectedWine = item.wines.find(wine => wine.collectionId === item.selectedCollectionId);
            return selectedWine?.collectionPrice || item.price;
        },
        handleWineSelection(collectionId) {
            const collectionIndex = this.collectionsList.findIndex(c =>
                c.wines.some(w => w.collectionId === collectionId)
            );

            if (collectionIndex !== -1) {
                const collection = this.collectionsList[collectionIndex];
                const selectedWine = collection.wines.find(w => w.collectionId === collectionId);

                if (selectedWine) {
                    this.$store.commit(MOrders.UPDATE_COLLECTION_WINE, {
                        collectionIndex,
                        selectedCollectionId: collectionId,
                        price: selectedWine.collectionPrice
                    });
                }
            }
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
    }
}
</script>

<style scoped>
    .collection-gift-item-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        align-self: stretch;
    }
    .collection-gift-item {
        min-height: 254px;
        width: 100%;
        position: relative;
    }
    .advent-day-badge {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 64px;
        height: 64px;
        border-radius: 6px;
        background: linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%);
        border: 2px solid #d4a574;
        box-shadow:
            0 2px 4px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.8),
            inset 0 -1px 0 rgba(0, 0, 0, 0.05),
            0 0 0 1px rgba(212, 165, 116, 0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #8B4513;
        font-family: 'Montserrat', sans-serif;
        font-size: 20px;
        font-weight: 700;
        z-index: 10;
        transition: all 0.3s ease;
        cursor: pointer;
        overflow: hidden;
    }
    .advent-day-badge::before {
        content: '';
        position: absolute;
        top: 8px;
        right: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #d4a574;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
    }
    .advent-day-badge::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, transparent 0%, #d4a574 20%, #d4a574 80%, transparent 100%);
        opacity: 0.5;
    }
    .advent-day-badge:hover {
        transform: translateY(-2px) scale(1.05);
        box-shadow:
            0 4px 8px rgba(0, 0, 0, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.9),
            inset 0 -1px 0 rgba(0, 0, 0, 0.05),
            0 0 0 1px rgba(212, 165, 116, 0.5);
        border-color: #c89664;
    }
    .advent-day-badge:hover::before {
        background: #c89664;
        transform: scale(1.1);
    }
    .gift-bottle-img {
        width: 168px;
        height: 230px;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
        background-position: center;
    }
    .gift-wrapper {
        display: flex;
        padding: 24px 40px 24px 168px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 8px;
        border: 1px solid #CCC;
        background: white;
        margin-top: 54px;
        min-height: 200px;
        justify-content: center;
    }
    .gift-wrapper-row1 {
        display: flex;
        align-items: flex-start;
        gap: 40px;
        align-self: stretch;
    }
    .gift-wrapper-row1-wine {
        display: flex;
        width: 391px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .gift-wrapper-row1-price {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
    }
    .gift-wrapper-row1-price1 {
        color: #707070;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%;
    }
    .gift-wrapper-row1-price2 {
        color: #000;
        font-family: Montserrat, sans-serif;
        font-size: 19px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
    }
    .gift-wrapper-row1-price3 {
        color: #707070;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
    }
    .gift-wrapper-row1-price3 span {
        color: #000;
    }
    .gift-wrapper-row1-btn {
        display: flex;
        width: 170px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .gift-cart-btn, .gift-sold-label {
        display: flex;
        height: 36px;
        padding: 8px 16px;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 8px;
        background: #004F7F;
        color: white;
        font-family: Montserrat, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }
    .gift-sold-label {
        background: #8E8E93;
        cursor: not-allowed;
    }
    .gift-wrapper-row1-wine2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .gift-wrapper-row1-wine1 {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
    }
    .gift-flag {
        display: flex;
        margin-top: 2px;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        width: 24px;
        height: 14px;
        background-size: cover !important;
    }
    .gift-title {
        color: #404040;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
    }
    .gift-wrapper-row1-wine2-text {
        color: #000;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
    }
    .redwine {
        background: url('../../assets/red.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .whitewine {
        background: url('../../assets/white.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .champagne {
        background: url('../../assets/rose.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .gift-wrapper-line {
        height: 1px;
        background: #cccccc;
        width: 100%;
    }
    .gift-wrapper-row2 {
        color: #000;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 20px;
    }

    .country-flag {
        width: 30px;
        height: 15px;
        background-size: contain !important;
        display: block;
        top: 1px;
        position: absolute;
    }
    .sold-label {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 130px;
        height: 36px;
        background: #efefef;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #000;
        margin-top: 6px;
        text-align: center;
        float: right;
    }
    .sold-label-fr {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 130px;
        height: 36px;
        background: #efefef;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #000;
        margin-top: 34px;
        text-align: center;
        float: right;
    }
    .additional-info {
        display: none;
        padding: 18px;
        background: #FFFFFF;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        -moz-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        position: absolute;
        left: calc(100% - 14px);
        z-index: 3;
        width: 100%;
    }
    .additional-info.last-item {
        left: unset;
        right: calc(100% - 14px);
    }
    .arrow-right {
        content: '';
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        left: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }
    .arrow-left {
        content: '';
        display: none;
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        right: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }
    .additional-info.last-item .arrow-right {
        display: none;
    }
    .additional-info.last-item .arrow-left {
        display: block;
    }

    .additional-info-wines {
        margin-top: 16px;
    }
    .additional-info-subtitle {
        font-family: Roboto, sans-serif;
        size: 14px;
        line-height: 19px;
        color: #707070;
    }
    .additional-info-title {
        font-family: Roboto, sans-serif;
        size: 16px;
        line-height: 19px;
        color: #000000;
        font-weight: 500;
        position: relative;
    }
    .country-flag-icon {
        width: 30px;
        height: 15px;
        background-size: contain;
        display: block;
        top: 1px;
        position: absolute;
    }
    .wine-vintage-name {
        display: inline-block;
        text-indent: 40px;
    }
    .background-shadow {
        background: linear-gradient(180deg, rgba(0, 48, 77, 0) 0%, #00304D 100%);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 188px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .background-shadow:hover {
        cursor: pointer;
    }
    .collection-item {
        display: inline-block;
        width: calc((100% - 48px)/3);
        margin-right: 24px;
        margin-bottom: 46px;
        border-radius: 8px;
        background: transparent;
        vertical-align: top;
        box-shadow: none !important;
    }
    .collection-item:hover {
        cursor: pointer;
    }
    .collection-item:hover .additional-info {
        display: block;
    }
    .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
    .header-img {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        width: 100%;
        height: 188px;
        position: relative;
        background-size: cover;
        background-position-y: center;
    }
    .collection-header {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        color: #ffffff;
        position: absolute;
        bottom: 16px;
        left: 16px;
        white-space: pre-line;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        z-index: 2;
        width: calc(100% - 32px);
    }
    .background-shadow:hover .collection-header {
        color: var(--brand)
    }
    .collection-subtitle {
        height: 66px;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #002840;
        margin: 8px 0 16px;
    }
    .investments-wrapper-left,
    .investments-wrapper-right {
        display: inline-block;
        width: calc(50% - 2px);
        vertical-align: top;
    }
    .investments-wrapper-right {
        text-align: right;
    }
    .investments-percentages {
        height: 4px;
    }
    .investments-percentages .collection-percent {
        display: inline-block;
        width: calc((100% - 8px) / 3);
        background: rgba(0, 0, 0, 0.16);
        height: 4px;
        border-radius: 2px;
        vertical-align: top;
    }
    .investments-percentages .collection-percent:nth-child(1),
    .investments-percentages.investments-percentages-2 .collection-percent:nth-child(2),
    .investments-percentages.investments-percentages-3 .collection-percent:nth-child(2),
    .investments-percentages.investments-percentages-3 .collection-percent:nth-child(3) {
        background: #E5CB87;
    }
    .cart-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: white;
        margin-top: 6px;
    }
    .cart-btn-it {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 4px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 13px;
        color: white;
        margin-top: 6px;
    }
    .cart-btn-fr {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 145px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: white;
        margin-top: 34px;
    }
    .collection-price {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: #002840;
        margin-bottom: 2px;
    }
    .collections-save {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #002840;
    }
    .investment-horizon-wrapper {
        height: 64px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 0 0 8px 8px;
        padding: 8px;
    }
    .investment {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #002840;
    }

    .case-size-select {
        margin-top: 0;
        padding-top: 0;
        min-width: 100px;
    }

    .case-size-select ::v-deep .v-input__control {
        min-height: 24px !important;
    }

    .case-size-select ::v-deep .v-input__slot {
        min-height: 24px !important;
        padding: 0 6px !important;
    }

    .case-size-select ::v-deep .v-select__selection {
        color: #000;
        font-family: Roboto, sans-serif;
        font-size: 14px;
    }

    @media(max-width: 767px) {
        .case-size-select {
            width: 70px !important;
        }
    }

    @media(min-width: 768px) and (max-width: 1024px) {
        .collection-item {
            width: 380px;
            margin: 0 auto 20px;
            box-sizing: border-box;
            display: block;
        }
    }

    @media(max-width: 767px) {
        .gift-wrapper-row1-wine {
            gap: 8px;
        }
        .gift-wrapper-row1-wine2 {
            flex-direction: row;
            gap: 16px;
        }
        .swiper-button-next,
        .swiper-button-prev {
            display: none;
        }
        .collection-item {
            width: 100%;
            margin-right: 0;
            margin-left: 0;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
        .collection-item:hover .additional-info, .gift-wrapper-line {
            display: none;
        }
        .gift-bottle-img {
            width: 40px;
            height: 160px;
            left: calc((100% - 40px) / 2);
        }
        .gift-wrapper {
            padding: 125px 16px 16px 16px;
            height: auto;
        }
        .collection-gift-item {
            height: auto;
        }
        .advent-day-badge {
            width: 56px;
            height: 56px;
            font-size: 18px;
            top: 8px;
            right: 8px;
            border-width: 2px;
        }
        .advent-day-badge::before {
            width: 6px;
            height: 6px;
            top: 6px;
            right: 6px;
        }
        .gift-wrapper-row1 {
            flex-direction: column;
            gap: 16px;
        }
        .gift-wrapper-row1-btn, .gift-wrapper-row1-wine {
            width: 100%;
        }
    }
</style>

<style>
    .collection-item .v-card__text {
        padding: 0;
    }
    .gift-wrapper-row1-price3 .v-select.v-text-field:not(.v-text-field--single-line) input {
        width: 0;
        border: 0;
    }
    .gift-wrapper-row1-price3 .v-text-field__details {
        display: none;
    }
    .home .home-more-collections .swiper-container {
        height: 380px !important;
        margin-bottom: 32px;
    }
</style>
